<template>
  <div class="certification-page" v-slideIn>
    <div class="page-head-container">
      <PageHead pageName="资质认证" />
    </div>
    <Steps :current="3" />
    <div class="page-wrapper" v-loading.lock="loading">
      <div v-if="loading" class="page-empty"></div>
      <div v-else>
        <div class="form-area">
          <BaseInfo
            :certification="certification"
            :categoryInfo="categoryInfo"
            :hasSupplier="hasSupplier"
            :hasPurchaser="hasPurchaser"
            :canUpdateSupplier="false"
            :canUpdatePurchaser="false"
            @updateCertInfo="fetchData"
          >
            <div class="form-block" v-if="hasSupplier || hasPurchaser">
              <h3 class="head">开户信息</h3>
              <div class="form-item">
                <span class="form-item-label">开户许可证:</span>
                <div class="form-item-inner form-item-inner--imgs">
                  <div class="form-item-inner--imgs-item">
                    <img
                      v-if="certification.accountLicense"
                      :src="certification.accountLicense"
                    />
                    <div class="placeholder" v-else></div>
                  </div>
                </div>
              </div>
              <div class="form-item">
                <span class="form-item-label">开户行:</span>
                <div class="form-item-inner form-item-inner--text">
                  {{ certification.openBank }}
                </div>
              </div>
              <div class="form-item">
                <span class="form-item-label">户名:</span>
                <div class="form-item-inner form-item-inner--text">
                  {{ certification.accountName }}
                </div>
              </div>
              <div class="form-item">
                <span class="form-item-label">帐号:</span>
                <div class="form-item-inner form-item-inner--text">
                  {{ certification.accountNo }}
                </div>
              </div>
            </div>
          </BaseInfo>
          <div class="form-buttons">
            <span class="btn-container">
              <Button type="hollow-red" text="上一步" :onClick="goBack" />
            </span>
            <span class="btn-container">
              <Button type="danger" text="下一步" :onClick="goPlatformIndex" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api';
  import {
    routes,
    platformCode,
    indentityCode,
    certificationStatusCode,
    openningAndOpenedStatus,
  } from '@/config';

  import PageHead from '@/components/PageHead/index.vue';
  import Steps from '@/components/Steps/index.vue';
  import Button from '@/components/Button';
  import BaseInfo from './baseInfo';

  import { mixins, validIsSupplier, validIsPurchaser } from '@/utils';

  export default {
    name: 'view-company-certification',
    data() {
      return {
        certification: {},
        loading: true,
        categoryTree: [],
        openedPlatformList: [],
        certStatus: {
          hasCert: false,
          isAuditPass: false,
          auditStatus: '',
          hasRejectCert: false,
          isEnterpriseCert: false,
          isIndividualCert: false,
          hasAdditionalCert: false,
          hasFundsAccount: false,
          identities: [],
        },
      };
    },
    methods: {
      async fetchData() {
        return api.getCertificationInfo().then((data) => {
          if (data.code === 0) {
            this.certification = data.data;
          }
        });
      },
      async init() {
        this.loading = true;
        await this.getSupplyCategoryTree();
        await this.getServicesInfo();
        await this.fetchData();
        this.loading = false;
      },
      goBack() {
        this.$router.replace({
          path: routes.chooseService,
          params: this.$route.params,
          query: this.$route.query,
        });
      },
      goPlatformIndex() {
        this.$router.push({
          path: routes.platformIndex,
          params: this.$route.params,
          query: {
            ...this.$route.query,
            platformList: this.openedPlatformListCode.join(','),
          },
        });
      },
      getServicesInfo() {
        return api
          .getServiceInfo({
            token: this.token,
          })
          .then((data) => {
            if (data && data.code === 0) {
              this.openedPlatformList = data.data;
            }
          });
      },
      getSupplyCategoryTree() {
        return api.getSupplyCategoryTree({ platformCode: 'bid' }).then(res => {
          this.categoryTree = res.data;
        });
      },
    },
    computed: {
      categoryInfo() {
        return {
          treeData: this.categoryTree,
          supplierKeys: this.certification.supplyCategory || [],
          purchaserKeys: this.certification.purchaserCategory || [],
        };
      },
      hasSupplier() {
        return this.openedPlatformList.some(el => {
          return (
            (el.platformCode === platformCode.cenpur || el.platformCode === platformCode.bid) &&
            el.identity.find(i => {
              return (
                validIsSupplier(i.code) &&
                openningAndOpenedStatus.includes(i.status)
              );
            })
          );
        });
      },
      hasPurchaser() {
        return this.openedPlatformList.some(el => {
          return (
            (el.platformCode === platformCode.cenpur || el.platformCode === platformCode.bid) &&
            el.identity.find(i => {
              return (
                validIsPurchaser(i.code) &&
                openningAndOpenedStatus.includes(i.status)
              );
            })
          );
        });
      },
      hasCenpur() {
        return this.hasSupplier || this.hasPurchaser;
      },
      openedPlatformListCode() {
        return this.openedPlatformList
          .filter(el => {
            return (
              el.identity.length &&
              el.identity.some(el => openningAndOpenedStatus.includes(el.status))
            );
          })
          .map(el => el.platformCode);
      },
    },
    mounted() {
      this.init();
    },
    components: {
      Steps,
      BaseInfo,
      PageHead,
      Button,
    },
    mixins: [mixins],
  };
</script>
<style lang="scss" scoped>
  @import '../style';
</style>